import React from 'react';

/**
 * Reusable KWB logo lockup (no tagline).
 *
 * Uses the no-tagline mark (mountain/peak + KWB), which is cleaner and more
 * legible at small sizes than the version with the tagline baked in.
 *
 * Variants:
 *  - "black" -> kwb-logo-no-tagline-black.svg  (for light/white surfaces)
 *  - "white" -> kwb-logo-no-tagline-white.svg  (for dark/black surfaces)
 */
const KwbLogo = ({ variant = 'black', className = '', alt = 'Katherine William-Botrous', ...props }) => {
  const src = variant === 'white'
    ? '/assets/kwb-logo-no-tagline-white.svg'
    : '/assets/kwb-logo-no-tagline-black.svg';

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className={`h-8 w-auto md:h-10 ${className}`}
      {...props}
    />
  );
};

export default KwbLogo;
